"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = Field;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@headlessui/react");
function Field({ ...props }) {
    return (0, jsx_runtime_1.jsx)(react_1.Field, { ...props });
}
